<template>
    <section class="internal-page">
        <internal-page-header
            eyebrow="Materiais de apoio"
            title="Modelos de documentos"
            description="Acesse os modelos disponíveis para preparar sua documentação."
        />
        <v-container class="pa-0 mx-auto">
            <div
                v-if="dataset.description"
                class="internal-rich-text mb-8"
                v-html="dataset.description"
            ></div>
            <page-state v-if="loading" :loading="true" title="" description="" />
            <p v-else-if="!dataset.documents.length" class="document-models__empty">
                Os modelos de habilitação e divergência estão sendo atualizados. Se precisar de
                ajuda, <router-link to="/contato">fale com nossa equipe</router-link>.
            </p>
            <div v-else class="document-models">
                <a
                    v-for="item in dataset.documents"
                    :key="item.id"
                    :href="item.file_url"
                    :download="item.file_name"
                    target="_blank"
                    rel="noopener"
                    class="document-model"
                >
                    <span class="document-model__icon"
                        ><v-icon color="secondary">mdi-file-document-outline</v-icon></span
                    >
                    <div>
                        <small>Modelo · {{ fileExtension(item.file_name) }}</small>
                        <h2>{{ item.name }}</h2>
                        <p v-if="item.description" class="document-model__description">
                            {{ item.description }}
                        </p>
                    </div>
                    <v-icon color="primary">mdi-download</v-icon>
                </a>
            </div>
        </v-container>
    </section>
</template>

<script>
import axios from 'axios';

import { loadDynamicInfos } from '@/common/dynamic-info';

export default {
    name: 'DocumentsTemplates',

    data: () => ({
        loading: true,
        dataset: {
            description: '',
            documents: []
        }
    }),

    created() {
        this.load();
    },

    methods: {
        async load() {
            this.loading = true;
            const [description, documents] = await Promise.allSettled([
                loadDynamicInfos(['documents-template-description']),
                axios.get('/api/document-templates')
            ]);

            if (description.status === 'fulfilled')
                this.dataset.description =
                    description.value['documents-template-description'] || '';
            if (documents.status === 'fulfilled')
                this.dataset.documents = documents.value.data.content || [];

            this.loading = false;
        },

        fileExtension(name = '') {
            const extension = name.split('.').pop();
            return extension && extension !== name ? extension.toUpperCase() : 'Arquivo';
        }
    }
};
</script>

<style scoped>
.document-models__empty {
    padding: 28px;
    border: 1px dashed #dedbd4;
    border-radius: 8px;
    color: var(--pbb-muted);
}
.document-models {
    display: grid;
    gap: 16px;
}
.document-model {
    display: grid;
    grid-template-columns: 56px 1fr 24px;
    align-items: center;
    gap: 24px;
    padding: 28px;
    border: 1px solid #dedbd4;
    border-radius: 8px;
    background: #fff;
    color: var(--pbb-navy);
    text-decoration: none;
}
.document-model:hover {
    border-color: var(--pbb-copper);
}
.document-model__icon {
    display: grid;
    place-items: center;
    width: 56px;
    height: 56px;
    border-radius: 6px;
    background: var(--pbb-cream);
}
.document-model small {
    color: var(--pbb-muted);
    font-size: 11px;
}
.document-model__description {
    margin: 6px 0 0;
    color: var(--pbb-muted);
    font-size: 13px;
}
.document-model h2 {
    margin-top: 8px;
    font: 500 21px/1.4 'Plus Jakarta Sans', sans-serif;
    letter-spacing: -0.025em;
}
@media (max-width: 600px) {
    .document-model {
        grid-template-columns: 36px 1fr 20px;
        padding: 20px 16px;
        gap: 12px;
    }
    .document-model__icon {
        width: 36px;
        height: 44px;
    }
    .document-model h2 {
        font-size: 16px;
    }
}
</style>
